'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_presto$002e$002dTwo$002dFactor$002dAuth$002dView$0024$0024anon$002451 from "./presto.-Two-Factor-Auth-View$$anon$51.js";
import * as $j_presto$002etypes$0024 from "./presto.types$.js";
import * as $j_presto$002etypes$0024$002dTwo$002dFactor$002dAuth$0024 from "./presto.types$-Two-Factor-Auth$.js";
import * as $j_presto$002etypes$0024$002dTwo$002dFactor$002dAuth$002dId$0024 from "./presto.types$-Two-Factor-Auth-Id$.js";
import * as $j_presto$002etypes$0024$002dTwo$002dFactor$002dAuth$002dName$0024 from "./presto.types$-Two-Factor-Auth-Name$.js";
import * as $j_presto$002etypes$0024$002dTwo$002dFactor$002dAuth$002dPayload$0024 from "./presto.types$-Two-Factor-Auth-Payload$.js";
var $p;
/** @constructor */
function $c_Lpresto_TwoFactorAuthView$$anon$50() {
  this.bFd = null;
  this.bF5 = null;
  this.bF6 = false;
  this.bFe = null;
  this.bFf = false;
  this.bFi = null;
  this.bFb = null;
  this.bFc = false;
  this.bF7 = null;
  this.bF8 = false;
  this.bF9 = null;
  this.bFa = false;
  this.bFg = false;
  this.bFh = false;
  this.bFd = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_derivation_Configuration$().u;
  this.bFi = "TwoFactorAuth";
}
export { $c_Lpresto_TwoFactorAuthView$$anon$50 as $c_Lpresto_TwoFactorAuthView$$anon$50 };
$p = $c_Lpresto_TwoFactorAuthView$$anon$50.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_TwoFactorAuthView$$anon$50;
/** @constructor */
function $h_Lpresto_TwoFactorAuthView$$anon$50() {
}
export { $h_Lpresto_TwoFactorAuthView$$anon$50 as $h_Lpresto_TwoFactorAuthView$$anon$50 };
$h_Lpresto_TwoFactorAuthView$$anon$50.prototype = $p;
$p.F = (function(c) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_Decoder__tryDecode__Lio_circe_ACursor__s_util_Either(this, c);
});
$p.K = (function() {
  return this.bFd;
});
$p.M = (function() {
  if ((!this.bF6)) {
    this.bF5 = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__constructorNames__sci_List(this);
    this.bF6 = true;
  }
  return this.bF5;
});
$p.O = (function() {
  if ((!this.bFf)) {
    this.bFe = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__io$circe$derivation$ConfiguredDecoder$$decodersDict__sci_Map(this);
    this.bFf = true;
  }
  return this.bFe;
});
$p.D = (function() {
  return this.bFi;
});
$p.t = (function() {
  if ((!this.bFc)) {
    this.bFb = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("id", new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("created", new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("deleted", new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("name", new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("kind", new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("payload", $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$()))))));
    this.bFc = true;
  }
  return this.bFb;
});
$p.N = (function() {
  if ((!this.bF8)) {
    this.bF7 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon($j_presto$002etypes$0024$002dTwo$002dFactor$002dAuth$002dId$0024.$m_Lpresto_types$TwoFactorAuthId$().zs(), new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Decoder$().Z(), new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon(($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Decoder$(), new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lio_circe_Decoder$OptionDecoder($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Decoder$().Z())), new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon($j_presto$002etypes$0024$002dTwo$002dFactor$002dAuth$002dName$0024.$m_Lpresto_types$TwoFactorAuthName$().zt(), new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon($j_presto$002etypes$0024.$m_Lpresto_types$TwoFactorAuthType$().zv(), new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon($j_presto$002etypes$0024$002dTwo$002dFactor$002dAuth$002dPayload$0024.$m_Lpresto_types$TwoFactorAuthPayload$().zu(), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$()))))));
    this.bF8 = true;
  }
  return this.bF7;
});
$p.Q = (function() {
  if ((!this.bFa)) {
    this.bF9 = new $j_presto$002e$002dTwo$002dFactor$002dAuth$002dView$0024$0024anon$002451.$c_Lpresto_TwoFactorAuthView$$anon$51();
    this.bFa = true;
  }
  return this.bF9;
});
$p.v = (function() {
  if ((!this.bFh)) {
    this.bFg = false;
    this.bFh = true;
  }
  return this.bFg;
});
$p.G = (function(c) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__decodeProduct__Lio_circe_HCursor__F1__s_util_Either(this, c, new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sjsr_AnonFunction1(((\u03b4scrutinee472) => ((p) => \u03b4scrutinee472.zk(p)))($j_presto$002etypes$0024$002dTwo$002dFactor$002dAuth$0024.$m_Lpresto_types$TwoFactorAuth$())));
});
var $d_Lpresto_TwoFactorAuthView$$anon$50 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_TwoFactorAuthView$$anon$50, "presto.TwoFactorAuthView$$anon$50", ({
  SW: 1,
  a: 1,
  f: 1,
  h: 1,
  d: 1
}));
export { $d_Lpresto_TwoFactorAuthView$$anon$50 as $d_Lpresto_TwoFactorAuthView$$anon$50 };
//# sourceMappingURL=presto.-Two-Factor-Auth-View$$anon$50.js.map
